import { render } from "./Saving_Accounts.vue?vue&type=template&id=709fd263"
import script from "./Saving_Accounts.vue?vue&type=script&lang=js"
export * from "./Saving_Accounts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__